import React, { useEffect, useState } from "react";
import chata from "../assets/Group 28.png";
import bee from "../assets/Group 32.png";
import tron from "../assets/image 1.png";
import beecon from "../assets/2fc3f0e34c02f1e7c3ee7300f506492b1f723e7d.png";
import smallbee from "../assets/8f3479b9762001f0370cb94e488635a5a1211592.gif";
import capbee from "../assets/Group 25.png";
import { HiSwitchVertical } from "react-icons/hi";
import { IoCopy } from "react-icons/io5";
import About from "../About/About";
import { useWeb3ModalAccount } from "@web3modal/ethers/react";
import Web3 from "web3";
import { beeplanABI, beeplanAddress } from "../Contract/BeePlan";
import { usdtTokenABI, usdtTokenAddress } from "../Contract/USDT";
import { beeTokenABI, beeTokenAddress } from "../Contract/BeeToken";
import Hero from "../Hero/Hero";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";

const options = [
  { id: 1, name: "USDT", img: tron },
  { id: 2, name: "  BEE", img: beecon },
];

function Buy({block,splitCountdown,round}) {
  const { address: account, chainId } = useWeb3ModalAccount();
  const isBSC = chainId === 97;
  const [selected, setSelected] = useState(options[0]);
  const [selectedOption, setSelectedOption] = useState(options[0]); // Default USDT
  // const [round, setRound] = useState();
  const [winner, setWinner] = useState();
  // const [block, setBlock] = useState();
  const [jackpot, setJackpot] = useState();
  const [numUnit, setNumUnit] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [costBEE, setCostBEE] = useState(0);
  const [costUSDT, setCostUSDT] = useState(0);
  const [displayCost, setDisplayCost] = useState(0);
  const [open, setOpen] = useState(false);
  const [unit, setUnit] = useState("");
  const [referral, setReferral] = useState("");
  const ownerAddress = "0x123c64e6FAa7a4dB8eeE068Fd48Dba235604cFc1 "; // Replace with your actual owner address
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const handleChange = (e) => {
    const value = e.target.value;
    if (value >= 1 && value <= 5) {
      setUnit(value);
    } else if (e.target.value === "") {
      setUnit("");
    }
  };
  const web3 = new Web3(window.ethereum);
  const beePlanContract = new web3.eth.Contract(beeplanABI, beeplanAddress);
  const USDTContract = new web3.eth.Contract(usdtTokenABI, usdtTokenAddress);
  const BeeTokenContract = new web3.eth.Contract(beeTokenABI, beeTokenAddress);

  useEffect(() => {
    if (!unit) return;

    const fetchQuote = async () => {
      if (!account || !isBSC) {
        setErrorMessage("Please connect to Binance Smart Chain Testnet.");
        return;
      }

      try {
        const data = await beePlanContract.methods.quote(unit).call();

        console.log("Contract response:", data);

        // If array format: [costBEE, costUSDT]
        const us = data[0];
        const be = data[1];

        const bee = Number(be) / 1e18;
        const usdt = Number(us) / 1e18;

        setCostBEE(bee);
        setCostUSDT(usdt);

        setDisplayCost(selected.name.trim() === "BEE" ? bee : usdt);

        console.log("BEE:", bee, "USDT:", usdt);
      } catch (error) {
        console.error("Error fetching quote:", error);
      }
    };

    fetchQuote();
  }, [unit, selected]);

  // Purchase with USDT
  const handleUSDT = async () => {
    try {
      await beePlanContract.methods.withdrawUSDT(round).send({ from: account });
      toast.success("withdraw with USDT");
    } catch (error) {
      console.error("USDT withdraw Failed", error);
      toast.error("USDT withdraw Failed");
    }
  };

  // Purchase with BEE
  const handleBEE = async () => {
    try {
      await beePlanContract.methods.withdrawBEE(round).send({ from: account });
      toast.success("withdraw with BEE");
    } catch (error) {
      console.error("BEE withdraw Failed", error);
      toast.error("BEE withdraw Failed");
    }
  };
  const [referralLink, setReferralLink] = useState("");

  const getReferralId = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("ref") || "1";
  };

  // const getLastQueueId = async () => {
  //   const data = await beePlanContract.methods.getQueueIdsByAddress(account).call();
  //   if (data.length === 0) return null;
  //   return data[data.length - 1];
  // };
  const [blockCountdown, setBlockCountdown] = useState(0);
  const generateReferralLink = async () => {
    try {
      const data = await beePlanContract.methods
        .getQueueIdsByAddress(round, account)
        .call();
      console.log("ReferralLink", data);

      const lastId = data && data.length > 0 ? data[data.length - 1] : "1";
      const link = `${window.location.origin}?ref=${lastId}`;
      setReferralLink(link);
      console.log("ReferralLink", referralLink);
    } catch (error) {
      console.error("Error generating referral link", error);
      // fallback to default
      const link = `${window.location.origin}?ref=1`;
      setReferralLink(link);
    }
  };
  useEffect(() => { 
    generateReferralLink(); // Call the fetchWinner function
  }, [round, account, isBSC]); // Dependency array for useEffect
  const checkUSDTBalance = async () => {
    const balance = await USDTContract.methods.balanceOf(account).call();
    return Number(balance) >= costBEE ;
  };

  const checkBEEBalance = async () => {
    const balance = await BeeTokenContract.methods.balanceOf(account).call();
    return Number(balance) >= costBEE ;
  };

  // const currentRound = async () => {
  //   if (!account || !isBSC) {
  //     setErrorMessage("Please connect to Binance Smart Chain Testnet.");
  //     return;
  //   }
  //   try {
  //     const data = await beePlanContract.methods.currentRound().call();
  //     setRound(data);
  //     console.log("round", data);
  //   } catch (error) {
  //     console.error("Error fetching round:", error);
  //   }
  // };

  // Fetch jackpot for the round
  const getJackpot = async () => {
    if (!account || !isBSC) return;
    try {
      const data = await beePlanContract.methods.getJackpot(round).call();
      setJackpot(parseFloat(data) / 1e18);
      console.log("Jackpot:", data);
    } catch (error) {
      console.error("Error fetching jackpot:", error);
    }
  };

  // Fetch current winner and block countdown
  const getCurrentJackpotWinner = async () => {
    if (!account || !isBSC) return;
    try {
      // const winnerData = await beePlanContract.methods
      //   .getCurrentJackpotWinner(round)
      //   .call();
      const remaining = await beePlanContract.methods
        .getRemainingBlocks(round)
        .call();
      // setWinner(Number(winnerData));
      console.log("Remaining blocks:", remaining);
    } catch (error) {
      console.error("Error fetching winner or remaining blocks:", error);
    }
  };

 
  const [quid,setQuid]=useState("")
  const getUserInfo = async () => {
    if (!account || !isBSC) return;
    try {
      const userInfoArray = await beePlanContract.methods
        .getUserInfo(account, round)
        .call();
  
      if (userInfoArray.length > 0) {
        const latestEntry = userInfoArray[userInfoArray.length - 1];
        const extractedQuid = latestEntry[5]; // 5th index
        setQuid(Number(extractedQuid)); // store it as a number
        console.log("Extracted Quid:", extractedQuid);
      } else {
        setQuid(0); // fallback if array is empty
      }
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };
  
  useEffect(() => {
    let interval;
  
    if (account && isBSC) {
      getUserInfo(); // initial fetch
  
      interval = setInterval(() => {
        getUserInfo();
      }, 1000); // every 1 second
    }
  
    return () => {
      clearInterval(interval); // cleanup on unmount or change
    };
  }, [account, isBSC, round]);
  // USDT Approval
  const approveUSDT = async () => {
    setLoading(true);
    // getUserInfo()
    const waiunit = costUSDT * 1e18;
    try {
      await USDTContract.methods
        .approve(beeplanAddress, waiunit)
        .send({ from: account });
      toast.success("USDT Approved");
    } catch (error) {
      console.error("USDT Approval Failed", error);
      toast.error("USDT Approval Failed");
    }
  };

  // BEE Approval
  const approveBEE = async () => {
    setLoading(true);
    // getUserInfo()
    const waiunit = costBEE * 1e18;
    try {
      await BeeTokenContract.methods
        .approve(beeplanAddress, waiunit)
        .send({ from: account });
      toast.success("BEE Approved");
    } catch (error) {
      console.error("BEE Approval Failed", error);
      toast.error("BEE Approval Failed");
    }
  };

  const purchaseUSDT = async () => {
    const hasBalance = await checkUSDTBalance();
    if (!hasBalance) return toast.error("Insufficient USDT balance");
    if (block === 0) return toast.error("Cannot purchase yet.");
    console.log("block:", block);

    setLoading(true);
    const referralId = getReferralId();
    console.log("referral id used:", referralId);
    console.log("quid id used:", quid);

    const idToUse = quid === 0 ? referralId : quid;
  
    try {
      await approveUSDT();
      console.log("referral id used:", idToUse);
      await beePlanContract.methods
        .purchaseWithUSDT(unit, idToUse)
        .send({ from: account });
  
      toast.success("USDT Purchase Successful");
  
      // ✅ Update referral link after successful purchase
      await generateReferralLink();
      setUnit("");
      setCostBEE("");
        setDisplayCost("0");
    } catch (err) {
      console.error(err);
      toast.error("USDT Purchase Failed");
    }
    setLoading(false);
  };
  
  const purchaseBEE = async () => {
    const hasBalance = await checkBEEBalance();
    if (!hasBalance) return toast.error("Insufficient BEE balance");
    if (block === 0) return toast.error("Cannot purchase yet.");
  
    const referralId = getReferralId();

    const idToUse = quid === 0 ? referralId : quid;
  
    try {
      await approveBEE();
      setLoading(true);
      await beePlanContract.methods
        .purchaseWithBEE(unit, idToUse)
        .send({ from: account });
        
        toast.success("BEE Purchase Successful");
        await generateReferralLink();
        setUnit("");
        setCostBEE("");
        setDisplayCost("");
    } catch (err) {
      console.error(err);
      toast.error("BEE Purchase Failed");
    }
    setLoading(false);
  };
    
  // Withdraw jackpot when split countdown is zero
  const withdrawJackpot = async () => {
    // Only proceed if both blockCountdown and splitCountdown are 0
    if (block !== 0 || splitCountdown !== 0) {
      return toast.error("Cannot withdraw yet.");
    }
  
    setLoading2(true);
    try {
      await beePlanContract.methods
        .withdrawJackpot(round)
        .send({ from: account });
  
      toast.success("Jackpot withdrawn");
  
      // Start split countdown after withdrawal
    } catch (err) {
      console.error(err);
      toast.error("Withdrawal Failed");
    } finally {
      setLoading2(false);
    }
  };
  

  // Initial data
  // useEffect(() => {
  //   if (account && isBSC) currentRound();
  // }, [account, isBSC]);

  // When round changes, fetch data
  useEffect(() => {
    if (round && account && isBSC) {
      getCurrentJackpotWinner();
      getJackpot();
    }
  }, [round, account, isBSC]);

  // Block countdown interval
  useEffect(() => {
    let interval;
    if (blockCountdown  && account && isBSC) {
      interval = setInterval(getCurrentJackpotWinner, 1000);
    }
    return () => clearInterval(interval);
  }, [blockCountdown, account, isBSC]);

  useEffect(() => {
    setReferralLink(`${window.location.origin}?ref=1`);
    
  }, [round]);

  return (
    <div>
      <ToastContainer />
      <div className="row m-0 p-0">
        <div className="col-12 col-md-2 p-0 d-flex justify-content-center align-items-center">
          <img
            src={smallbee}
            alt=""
            className="smabeer"
            width={100}
            height={100}
          />
        </div>
        <div className="col-12 col-md-8 tree">
          <div className="d-block d-md-flex justify-content-around  align-items-center">
            <p className="fs-4 fw-bold m-0">Buy With </p>
            <div className="inputbox d-flex justify-content-between align-items-center">
              <input
                type="number"
                placeholder="1 Unit"
                value={unit}
                onChange={handleChange}
                min={1}
                max={5}
              />
              <div className="d-flex">
                <p className="fs-4 fw-bold m-0 p-0 mt-1 text-white">
                  {displayCost}
                </p>
                <p
                  className="my-1 mx-2"
                  style={{ borderRight: "1px solid black" }}
                ></p>
                <div className="custom-selector">
                  <div className="selected" onClick={() => setOpen(!open)}>
                    <img src={selected.img} alt="avatar" />
                    <span>{selected.name}</span>
                  </div>
                  {open && (
                    <div className="options">
                      {options.map((opt) => (
                        <div
                          key={opt.id}
                          className="option"
                          onClick={() => {
                            setSelected(opt);
                            setOpen(false);
                          }}
                        >
                          <img src={opt.img} alt="avatar" />
                          <span>{opt.name}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="w-100 d-flex justify-content-center">
            <button
              className="bg-black text-white fs-2 px-2 py-0"
              style={{
                border: "4px solid rgb(236, 185, 31)",
                borderRadius: "12px",
              }}
            >
              <HiSwitchVertical className="p-0" />
            </button>
          </div>

          <div className="d-block d-md-flex justify-content-around gap-4 align-items-center">
            <p className="fs-4 fw-bold m-0">Receive </p>
            <div className="inputbox d-flex justify-content-between align-items-center">
              <input
                type="number"
                placeholder="1 Unit"
                value={costBEE / 2}
                readOnly
              />
              <div className="d-flex">
                <p
                  className="my-1 mx-2"
                  style={{ borderRight: "1px solid black" }}
                ></p>
                <div className="custom-selector">
                  <div className="selected">
                    <img src={beecon} alt="avatar" />
                    <span>BEE</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flexxx d-md-flex mt-4 justify-content-center">


  <button
    className="connect mt-2"
    onClick={() =>
      selected.name === "USDT" ? purchaseUSDT() : purchaseBEE()
    }
  >
    {loading ? (
      <span className="spinner-border spinner-border-sm" />
    ) : (
      "Buy Now"
    )}
  </button>

           
          </div>
          
          {referralLink && (
            <div className="d-block d-md-flex justify-content-around  align-items-center mt-4">
              <p className="fs-4 fw-bold m-0">Referral Link</p>
              <div className="reffeal d-flex justify-content-around align-items-center">
                <p className="m-0 text-break">{referralLink}</p>
                <p
                  className="m-0"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigator.clipboard.writeText(referralLink);
                    toast.success("Referral link copied!", {
                      // position: "top-center",
                      autoClose: 1500,
                    });
                  }}
                >
                  <IoCopy />
                </p>
              </div>
            </div>
          )}

          <Link
            to="/info"
            className="mt-4 d-flex justify-content-end text-black fs-4"
          >
            See last Transactions
          </Link>
          <div className=" flexxx d-md-flex  justify-content-end gap-3">
  

  {/* Actual button */}
  <button
    className="connect mt-2"
    onClick={withdrawJackpot}
  >
    {loading2 ? (
      <span className="spinner-border spinner-border-sm" />
    ) : (
      "Withdraw Jackpot"
    )}
  </button>

            <button className="connect mt-2" onClick={handleUSDT}>
              <span>Withdraw USDT</span>
            </button>

            <button className="connect mt-2" onClick={handleBEE}>
              <span>Withdraw $BEE</span>
            </button>
          </div>
        </div>
        <div className="col-12 col-md-2 d-flex justify-content align-items-center">
          <img src={capbee} alt="" className="" width={170} height={170} />
        </div>
      </div>
      <About />
    </div>
  );
}

export default Buy;
